import { render, staticRenderFns } from "./EstimatedDaysExhaustionComponent.vue?vue&type=template&id=7c78c564&"
import script from "./EstimatedDaysExhaustionComponent.vue?vue&type=script&lang=js&"
export * from "./EstimatedDaysExhaustionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports